import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import LiveChat from "../components/LiveChat";
import { useAuthContext } from "../contexts/AuthContext";
import { useSubdomain } from "../hooks/useSubdomain";

export default function AppLayout() {
  const { user } = useAuthContext();
  const { isSubdomain } = useSubdomain();
  const location = useLocation();
  const isInstructor = user?.role === "instructor";
  
  // Check if current page is Landing page
  const isLandingPage = location.pathname === "/";
  
  // Check if current page is Subscription Checkout (hide navbar)
  const isSubscriptionCheckout = location.pathname === "/subscription/checkout-new" 
    || location.pathname === "/subscription/register-info"
    || location.pathname === "/subscription/register-success";

  // On subdomain, render nothing - SubdomainHandler will handle the display
  if (isSubdomain) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-grayBG">
      {!isSubscriptionCheckout && <Navbar transparent={true} />}
      <div className={`flex-1 ${isLandingPage ? '' : 'px-4 pt-4'}`}>
        <Outlet />
      </div>
      {isInstructor && <LiveChat />}
    </div>
  );
}
